import { QueryClient } from "@sveltestack/svelte-query";

export const appQueryClient = new QueryClient();